module.exports = __webpack_public_path__ + "static/media/faq-arrow.4d68007a.svg";